import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import DocumentoVersao from "./DocumentoVersao";
import Usuario from "model/administracao/cadastro/Usuario";

export default class DocumentoVersaoInteressado {
    id: number;
    documentoVersao: DocumentoVersao | null;
    grupo: GrupoUsuarios | null;
    usuario: Usuario | null;

    constructor() {
        this.id = 0;
        this.documentoVersao = null;
        this.grupo = null;
        this.usuario = null;
    }
}